import { RegistrationFooterContent } from "../registrationFooter/utils";
import { IBaseDisplayBehaviour } from "./IBaseDisplayBehaviour";

export class WebDisplayBehaviour implements IBaseDisplayBehaviour {
  getRegistrationFooterContentList(props: { registrationGdprConsentEnabled?: boolean; displayPoweredBy?: boolean }) {
    const contentList: RegistrationFooterContent[] = [];
    if (props.displayPoweredBy) {
      contentList.push(RegistrationFooterContent.POWERED_BY);
    }
    if (props.registrationGdprConsentEnabled) {
      contentList.push(RegistrationFooterContent.COOKIES);
    }
    return contentList;
  }
  canShowRegistrationHeader(): boolean {
    return true;
  }
  canShowTicketPageDescriptionInRegistration(): boolean {
    return true;
  }
  canShowTicketPageImageInRegistration(): boolean {
    return true;
  }
}
